query GetFacebookIntegration {
    facebookIntegration {
        hasAuthToken
        isEnabled
        userEmail
        pages {
            pageId
            name
            link
        }
    }
}
